import { render, staticRenderFns } from "./JobPostingList.vue?vue&type=template&id=05a91e70"
import script from "./JobPostingList.vue?vue&type=script&lang=js"
export * from "./JobPostingList.vue?vue&type=script&lang=js"
import style0 from "./JobPostingList.vue?vue&type=style&index=0&id=05a91e70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports